import React, { Fragment } from "react";
import { FormattedDate } from "react-intl";
import { Avatar, Box, IconButton } from '@material-ui/core';
import { CategoryTag, Event, Locale } from "../../core/api/model";
import { DashboardPanelListItem } from "../DashboardPanel";
import CustomIcon from "../../core/custom-icon";

export interface DashboardFavouritesEventsListItemProps {
  locale: Locale;
  event: Event;
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesEventsListItem = (props: DashboardFavouritesEventsListItemProps) => (
  <Fragment>

    <DashboardPanelListItem headline={props.event.eventTitle[props.locale]}
                            actionsDirection='column'
                            imageSlot={
                              <Avatar style={{width: '56px', height: '74px'}}
                                      alt={props.event.eventPic?.altText}
                                      src={props.event.eventPic?.url}
                                      color=''
                              >
                                <CustomIcon iconname='event'
                                            viewBox='0 0 16 16'
                                            fontSize='small'
                                />
                              </Avatar>
                            }
                            contentSlot={
                              <Fragment>
                                <Box display='flex' component='p' mt={0.8}>
                                  <CustomIcon iconname='date'
                                              viewBox='0 0 16 16'
                                              fontSize='small'
                                  />
                                  <Box component='span' ml={1}>
                                    <FormattedDate
                                      value={props.event.eventBegin}
                                      day="numeric"
                                      month="numeric"
                                      year="numeric"
                                      weekday="short"
                                    />
                                  </Box>
                                </Box>
                                <Box display='flex' component='p'>
                                  <CustomIcon iconname='time' viewBox='0 0 16 16' fontSize='small'/>
                                  <Box component='span' ml={1}>
                                    <FormattedDate
                                      value={props.event.eventBegin}
                                      hour='numeric'
                                      minute='numeric'
                                    />
                                  </Box>
                                </Box>
                              </Fragment>
                            }
                            actionsSlot={
                              <Fragment>
                                <IconButton aria-label=''
                                            color='primary'
                                            onClick={() => props.deleteFavourite( props.event.eventId, CategoryTag.Event)}
                                >
                                  <CustomIcon iconname='favourite' />
                                </IconButton>
                                <IconButton aria-label='mehr Informationen zum Termin'
                                            target='_blank'
                                            component='a'
                                            color='primary'
                                            href={props.event.expoSiteLink[props.locale]}
                                >
                                  <CustomIcon iconname='arrowLong' />
                                </IconButton>
                              </Fragment>
                            } />
  </Fragment> 
);
